<template>
    <div class="card text-light border-0 pb-4" >
        <img :src="dataHeader.image" class="header-image" alt="Header Image"/>
        <div class="card-img-overlay">
            <div class="container">
                <h5 class="card-title">{{dataHeader.title}}</h5>
                <p class="card-text w-50">
                    {{dataHeader.description}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    name: 'HeadMain',
    data() {
        return {
            loading: true,
            language: localStorage.getItem('language') || 'uz',
            dataHeader: {},
            navbarId: localStorage.getItem('navbar_item') || 1,
        }
    },
    methods: {
        async fetchHeader() {
            this.loading = true
            try {
                const { data } = await api.get(`/header/${this.navbarId}/`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataHeader = data
            } catch (error){
                // Xatolikni e’tiborsiz qoldiramiz
            } finally {
                this.loading = false
            }
        }
    },
     mounted() {
        this.fetchHeader();
    },
}
</script>

<style scoped>
.header-image {
  width: 100%;
  height: 480px;
  object-fit: cover;
}

@media (max-width: 992px) {
  .header-image {
    height: 350px;
  }
}

@media (max-width: 576px) {
  .header-image {
    height: 200px;
  }
}
</style>
